import { jsx as _jsx } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
import { Button } from '@skbkontur/react-ui';
import classes from './MatchLink.module.css';
export const MatchLink = ({ matchEmployeeLink }) => {
    return (_jsx(Link, { to: matchEmployeeLink, target: "_blank", className: classes.link, children: _jsx(Button, { use: "link", children: "\u041F\u0440\u043E\u0432\u0435\u0440\u044C\u0442\u0435 \u0435\u0433\u043E \u043A\u0430\u0440\u0442\u043E\u0447\u043A\u0443" }) }));
};
